<template>
    <div
        class="carrito-compras"
        v-if="!desactivar"
        ref="carrito"
        :class="{ fixed: isFixed, sticky: !isFixed }"
        :style="stickyStyles"
    >
        <div class="container">
            <div class="carrito-header">
                <div class="total-container" @click="toggleCart">
                    <div class="total-info">
                        <span ref="total">{{ $t('carrito_evento.total') }}: {{ total.toFixed(2) | formatear_precio }}</span>
                        <div class="product-counter">{{ totalItems }}</div>
                    </div>
                    <div class="arrow-icon">
                        <i v-if="!isExpanded" class="fa fa-chevron-up"></i>
                        <i v-else class="fa fa-chevron-down"></i>
                    </div>
                </div>
                <div class="carrito-boton">
                    <template v-if="!url.includes('productos')">
                        <button 
                            style="margin-right: 5px;" 
                            :class="{'btn-volver-padding': totalItems === 0}" 
                            class="btn-volver" 
                            @click="cambiarAsiento"
                        >
                            {{ $t('carrito_evento.volver') }}
                        </button>
                        <button
                            class="btn-continuar" 
                            :disabled="loading" 
                            @click="continuar"
                        >
                            {{ totalItems > 0 ? $t('carrito_evento.continuar') : $t('carrito_evento.continuar_sin_productos') }}
                        </button>
                    </template>
                    <button
                        v-else
                        class="btn-continuar"
                        :disabled="totalItems === 0" 
                        @click="continuar"
                    >
                        {{ $t('carrito_evento.continuar') }}
                    </button>
                </div>
            </div>
            <div v-if="isExpanded" class="carrito-contenido">
                <div class="container">
                    <div class="header-contenido">
                        <h4>{{ $t('carrito_evento.titulo') }}</h4>
                        <i class="fa fa-chevron-down" @click="toggleCart"></i>
                    </div>
                    
                    <div class="productos-listado">
                        <div class="entrada-detalle" v-for="(entrada, index) in groupedEntradas" :key="index">
                            <div class="entrada-info">
                                <span>{{ $t('carrito_evento.entrada') }}: {{ entrada.descripcion }} x{{ entrada.count }}</span>
                                <span class="precio-entrada">{{ entrada.precio | formatear_precio }} </span>
                            </div>
                        </div>
                        <div v-for="(product) in productos" :key="'producto-' + product.item.id" class="producto">
                            <span>{{ product.item.name }} x{{ product.units }}</span>
                            <div class="producto-detalles">
                                <span>{{ (product.item.price * product.units).toFixed(2) | formatear_precio }}</span>
                                <button class="btn-transparente" @click.stop="eliminarProducto(product.item.id)" :disabled="isDeleting">
                                    <i class="fa fa-trash btn-eliminar-transparente"></i>
                                </button>
                            </div>
                        </div>
                        <div v-for="(product) in productosListado" :key="'productoListado-' + product.item.id" class="producto">
                            <span>{{ product.item.name }} x{{ product.units }}</span>
                            <div class="producto-detalles">
                                <span>{{ (product.item.price * product.units).toFixed(2) | formatear_precio }}</span>
                                <i class="fa fa-trash btn-eliminar" @click.stop="removeFromCart(product.item.id)"></i>
                            </div>
                        </div>
                    </div>

                    <div class="carrito-total">
                        <span>{{ $t('carrito_evento.total') }}</span>
                        <span>{{ total.toFixed(2) | formatear_precio }} </span>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            plazas: {
                type: Array,
                default: () => [],
            },
            asientos: {
                type: Array,
                default: () => [],
            },
            entradas: {
                type: Array,
                default: () => [],
            },
            carrito_id: {
                type: Number,
                required: false,
            },
            desactivar: {
                type: Boolean,
                default:false,
                required: false,
            },
            productos: {
                type: Array,
                required: true,
            },
            productosListado: {
                type: Array,
                required: true,
            },
            containerRef: { 
                required: true,
            },
            loading:{
                required: false,
            },
            stickyMargin: {
                type: Number,
                default: -45
            },
            evento: {
                type: Object,
                required: false,
            },
            session_id: {
                required: false,
            },
        },
        data() {
            return {
                isExpanded: false,
                isFixed: true,
                ticking: false, 
                fixedThreshold: 20, 
                absoluteThreshold: 40,
                isDeleting: false,
            };
        },
        computed: {
            total() {
                return this.productos.reduce((sum, item) => {
                    return sum + (item.item.price * item.units);
                }, 0) + this.productosListado.reduce((sum, item) => {
                    return sum + (item.item.price * item.units);
                }, 0) + this.asientos.reduce((sum, asiento) => sum + Number(asiento.precioSeleccionado.precio), 0) 
                    + this.plazas.reduce((sum, plaza) => sum + (plaza.precioSeleccionado.precio), 0) 
                    + this.entradas.reduce((sum, entrada) => {
                        return sum + (Number(entrada.price) * entrada.unidades);
                    }, 0);
            },
            totalItems() {
                return this.productos.reduce((sum, item) => sum + item.units, 0) + this.productosListado.reduce((sum, item) => sum + item.units, 0);
            },
            stickyStyles() {
                if (!this.isFixed) {
                    return { marginBottom: this.stickyMargin + 'px' };
                }
                return {};
            },
            groupedEntradas() {
                const grouped = {};
                this.plazas.forEach(plaza => {
                    const descripcion = plaza.precioSeleccionado.descripcion;
                    if (!grouped[descripcion]) {
                        grouped[descripcion] = {
                            descripcion: descripcion,
                            count: 0,
                            precio: plaza.precioSeleccionado.precio
                        };
                    }
                    grouped[descripcion].count += 1;
                });
                this.asientos.forEach(asiento => {
                    const descripcion = asiento.precioSeleccionado.descripcion;
                    if (!grouped[descripcion]) {
                        grouped[descripcion] = {
                            descripcion: descripcion,
                            count: 0,
                            precio: Number(asiento.precioSeleccionado.precio)
                        };
                    }
                    grouped[descripcion].count += 1;
                });
                this.entradas.forEach(entrada => {
                    const descripcion = entrada.name;
                    if (!grouped[descripcion]) {
                        grouped[descripcion] = {
                            descripcion,
                            count: 0,
                            precio: Number(entrada.price)
                        };
                    }
                    grouped[descripcion].count += (entrada.unidades || 1);
                });
                return Object.values(grouped);
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            url() {
                return window.location.href;
            }
        },
        watch: {
            productosListado: {
                handler(newVal, oldVal) {
                    this.animateTotal();
                },
                deep: true,
            },
        },
        methods: {
            continuar() {
                if (this.evento) {
                    this.finalizarPasoUno();
                } else {
                    this.terminar();
                }
            },
            finalizarPasoUno() {
                if (this.productosListado.length > 0) {
                    let transformedProductos = [];
                    const productosDisponibles = this.productosListado.length > 0 ? this.productosListado : this.productos;
        
                    this.anadirProductosAlCarrito();
        
                    transformedProductos = productosDisponibles.map(product => ({
                        teatro_product_id: product.item.id,
                        event_id: this.evento.id,
                        event_session_id: this.session_id,
                        units: product.units
                    }));
        
                    const params = {
                        filters: {
                            tid: this.$store.getters.getTeatro.hash
                        },
                        cart_id: this.carrito_id,
                        productos: transformedProductos
                    };
        
                    this.$store
                        .dispatch(this.config.getVuexAlias('usuario.carrito.productos'), params)
                        .then(() => {
                            this.anadirProductosAlCarrito();
                            this.$nextTick(() => {
                                this.$emit('changeStep');
                            });
                        })
                        .catch(error => {
                            console.error('Error al añadir productos al carrito:', error);
                        })
                } else {
                    this.$nextTick(() => {
                        this.$emit('changeStep');
                    });
                }
            },
            anadirProductosAlCarrito() {
                this.productosListado.forEach(product => {
                    const existing = this.productos.find(item => item.item.id === product.item.id);
                    if (existing) {
                        existing.units += product.units;
                    } else {
                        this.productos.push(product);
                    }
                });
                this.$emit('update:productosListado', []);
            },
            handleOutsideClick(event) {
                const carrito = this.$refs.carrito;

                if (this.isExpanded && carrito && !carrito.contains(event.target)) {
                    this.isExpanded = false;
                }
            },
            toggleCart(event) {
                if (event) event.stopPropagation();
                this.isExpanded = !this.isExpanded;
            },
            eliminarProducto(productId){
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    cart_id: this.carrito_id,
                    cart_product_id: productId,
                    producto_id: productId
                };

                this.isDeleting = true;

                this.$store
                    .dispatch(this.config.getVuexAlias('usuario.carrito.productos.delete-products'), params)
                    .then(() => {
                        const index = this.productos.findIndex(item => item.item.id === productId);
                        if (index !== -1) {
                            this.productos.splice(index, 1); 
                        }
                    
                        if (this.productos.length === 0 && this.productosListado.length === 0) {
                            this.isExpanded = false;
                        }
                    })
                    .catch(error => {
                        console.error('Error al añadir productos al carrito:', error);
                    })
                    .finally(() => {
                        this.isDeleting = false;
                    });
            },
            removeFromCart(productId) {
                const index = this.productosListado.findIndex(item => item.item.id === productId);
                if (index !== -1) {
                    this.productosListado.splice(index, 1);
                }
                if (this.productosListado.length === 0 && this.productosListado.length === 0) {
                    this.isExpanded = false;
                }
            },
            terminar() {        
                this.$emit('terminar');
            },
            cambiarAsiento() {
                if (this.plazas && this.plazas.length > 0) {
                    this.$emit('cambiar-asiento', true, true);
                } else {
                    this.$emit('cambiar-asiento', false, true);
                }
                this.borrarSesion();
            },
            borrarSesion() {
                if (sessionStorage.getItem('session_id')) {
                    const params = {
                        session_id: sessionStorage.getItem('session_id'),
                        filters: {
                            session_id: sessionStorage.getItem('session_id'),
                            tid: this.configuracion.hash_teatro
                        },
                        tid: this.configuracion.hash_teatro,
                    };

                    this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                    });

                    sessionStorage.removeItem('session_id');
                }
            },
            handleScroll() {
                if (!this.ticking) {
                    window.requestAnimationFrame(() => {
                        this.updateFixedState();
                        this.ticking = false;
                    });
                    this.ticking = true;
                }
            },
            updateFixedState() {
                const container = this.containerRef; 
                const carrito = this.$refs.carrito;

                if (!container || !carrito) {
                    return;
                }

                const scrollTop = window.scrollY || window.pageYOffset;
                const containerBottom = container.offsetTop + container.offsetHeight;
                const windowBottom = scrollTop + window.innerHeight;
                const carritoHeight = carrito.offsetHeight;

                if (windowBottom >= containerBottom - carritoHeight - this.fixedThreshold) {
                    if (this.isFixed) {
                        this.isFixed = false;
                    }
                } else if (windowBottom < containerBottom - carritoHeight - this.absoluteThreshold) {
                    if (!this.isFixed) { 
                        this.isFixed = true;
                    }
                }
            },
            animateTotal() {
                const totalElement = this.$refs.total;
                if (totalElement) {
                    totalElement.classList.add('animate-total');
                    setTimeout(() => {
                        totalElement.classList.remove('animate-total');
                    }, 1000); 
                }
            },
        },
        mounted() {
            document.addEventListener("click", this.handleOutsideClick);
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleScroll);
            this.updateFixedState();
        },
        beforeDestroy() {
            document.removeEventListener("click", this.handleOutsideClick);
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleScroll);
        },
    };
</script>


<style scoped>
.carrito-compras {
    background-color: #151618;
    color: white;
    padding: 20px;
    width: 100%;
    z-index: 10;
    position: fixed;
    left: 0;
    bottom: 0;
    transition: all 0.3s ease;
}

.fixed {
    position: fixed;
    bottom: 0;
}

.sticky {
    position: sticky;
    margin-top: 20px;
    left: 0;
    bottom: 0;
}

.carrito-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.total-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
}

.total-info {
    position: relative;
    display: flex;
    align-items: center;
}
.product-counter {
    position: absolute;
    top: -13px;
    right: -13px;
    background-color: #e90000;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center; 
    font-weight: bold;
    padding-top: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.arrow-icon {
    position: relative;
    margin-left: 15px;
}

.arrow-icon i {
    font-size: 18px;
    color: white;
    cursor: pointer;
}



.carrito-contenido {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    background-color: #151618;
    border-top: 1px solid #ccc;
    padding: 20px;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
}

.productos-listado {
    max-height: 200px;
    overflow-y: auto;
    margin-bottom: 10px;
}

.entrada-detalle {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #1a1a1a;
    border: 1px solid #444444;
    border-radius: 4px;
}

.entrada-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.precio-entrada {
    margin-left: auto;
    margin-right: 25px;
    font-weight: bold;
    color: white;
    font-size: 16px;
}

.header-contenido {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.producto {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    border: 1px solid #444444;
    padding: 10px;
    border-radius: 4px;
}

.producto-detalles {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-eliminar {
    color: #e90000;
    cursor: pointer;
    font-size: 1.2em;
    margin-left: 10px;
}

.btn-eliminar:hover {
    color: #c70000;
}

.btn-eliminar-transparente {
    color: #e90000;
    cursor: pointer;
    font-size: 1.2em;
    padding-left: 2px;
    margin-right: -5px;
}

.btn-eliminar-transparente:hover {
    color: #c70000;
}

.carrito-total {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-top: 10px;
    border-top: 1px solid #ccc;
    padding-top: 10px;
}

small {
    display: block;
    margin-top: 10px;
    font-size: 0.8em;
}

.carrito-boton {
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-continuar {
    background-color: var(--altcolor);
    color: var(--alttextcolor);
    font-weight: bold;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    font-size: 0.8em;
    cursor: pointer;
    width: 100%;
    flex: 1;
}

.btn-volver {
    background-color: inherit;
    color: var(--alttextcolor);
    font-weight: bold;
    padding: 10px 20px;
    border: 1px solid white;
    border-radius: 4px;
    font-size: 0.8em;
    cursor: pointer;
    width: 100%;
    flex: 1;
}

.fa {
    cursor: pointer;
}

.producto-detalles span {
    font-size: 16px;
    font-weight: bold;
}

.carrito-compras .container {
    padding: 0 15px;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .carrito-compras {
        bottom: 39px;
    }
    .carrito-compras .container {
        padding: 0;
        margin: 0;
    }
}

.desactivado {
    pointer-events: none;
}

.animate-total {
    animation: scaleUp 1s forwards;
}

.btn-transparente {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.btn-volver-padding {
    padding: 17px 9px;
}

.productos-listado::-webkit-scrollbar {
    width: 6px;
}

.productos-listado::-webkit-scrollbar-track {
    background: transparent;
}

.productos-listado::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
}

.productos-listado::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}

@keyframes scaleUp {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes bounce {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
</style>

